import { connect } from 'react-redux'
import { RootState } from 'typesafe-actions';
import { ThunkDispatch } from 'redux-thunk';
import OrderFinalization from '../components/OrderFinalization';
import { resetOrder, getPaymentIntentAsyncThunk } from '../actions/OrderActions';
import { getRestaurantInfoAsyncThunk } from '../../AccountDetails/accountDetailsSlice';


const mapStateToProps = (state: RootState) => ({
    orderSheet: state.orderSheetsRdc.currentOrderSheet,
    quoteBusy: state.orderRdc.createOrderBusy || state.orderRdc.quoteOrderBusy,
    quotedOrder: state.orderRdc.quotedOrder,
    currentOrderId: state.orderRdc.currentOrderId,
    noneFulfillsOrder: state.orderRdc.noneFulfillsOrder,
    noneFulfillsDeadline: state.orderRdc.noneFulfillsDeadline,
    missingProducts: state.orderRdc.missingProducts,
    
    getPaymentIntentBusy: state.orderRdc.getPaymentIntentBusy,
    paymentIntentSecret: state.orderRdc.paymentIntentSecret,
    paymentCards: state.orderRdc.paymentCards, 
    restaurantDetails: state.accountDetailsRdc.restaurantDetails,
    getDeliveryAddressBusy: state.accountDetailsRdc.loadUserDetailsBusy,
})

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>): any => {
    return ({
        resetOrder: () => {
            dispatch(resetOrder())
        },
        getRestaurantAccountInfo: async () => {
            await dispatch(getRestaurantInfoAsyncThunk())
        },
        getPaymentIntent: async (orderId: number) => {
            await dispatch(getPaymentIntentAsyncThunk(orderId))
        }
    })
}

export type OrderFinalizationProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

export const OrderFinalizationCnctd = connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderFinalization);